import React from 'react';
import App from 'next/app';
import { ApolloProvider } from '@apollo/client';
import { ResponsiveImageProvider } from '@blaze-cms/image-cdn-react';
import { withBlaze } from '@blaze-cms/nextjs-tools';
import buildConfig from '../blaze.config';
// eslint-disable-next-line import/extensions -- copied project/ slot, absent until prepare runs
import ProjectAppWrapper from '../project/AppWrapper';
import IndexPage from '../components/IndexPage';
import { RESPONSIVE_IMAGE_CONFIG } from '../constants';
import RouteContextWrapper from '../Context/RouteContextWrapper';

import '../styles/sass/_fonts.scss';
import '../styles/tailwind-base.css';
import '../styles/sass/main.scss';
import '../styles/globals.css';

class MyApp extends App {
  render() {
    const { Component, pageProps, apolloClient, router } = this.props;

    return (
      <ApolloProvider client={apolloClient}>
        <ResponsiveImageProvider config={RESPONSIVE_IMAGE_CONFIG}>
          <RouteContextWrapper>
            <ProjectAppWrapper>
              <IndexPage />
              <div className="site-container">
                <Component {...pageProps} router={router} />
              </div>
            </ProjectAppWrapper>
          </RouteContextWrapper>
        </ResponsiveImageProvider>
      </ApolloProvider>
    );
  }
}

export default withBlaze(MyApp, buildConfig);
